import { useGame } from "../store/useGame";

/**
 * QW2 — jauge « Maintien de l'ordre » (index de répression 0..1).
 * Déplacée sous la grille d'indicateurs le 2026-06-15 (était dans la
 * MetaBar). Cachée sous 5 % (signal trop faible), 4 paliers au-dessus.
 */
function repressionLevel(
  value: number,
): { label: string; tone: string } | null {
  if (value < 0.05) return null;
  if (value < 0.2) return { label: "MAINTIEN DE L'ORDRE", tone: "low" };
  if (value < 0.4) return { label: "CONTRÔLE RENFORCÉ", tone: "mid" };
  if (value < 0.7) return { label: "RÉPRESSION ASSUMÉE", tone: "high" };
  return { label: "VERROUILLAGE AUTORITAIRE", tone: "extreme" };
}

export function OrderMeter() {
  const repressionIndex = useGame(
    (s) => s.worldState?.polity.repression_index ?? 0,
  );
  const repression = repressionLevel(repressionIndex);
  if (!repression) return null;
  const pct = Math.round(repressionIndex * 100);

  return (
    <div
      className="repression-meter"
      data-tone={repression.tone}
      title={`Index de répression : ${pct} %`}
    >
      <span className="repression-label">{repression.label}</span>
      <span className="repression-bar" aria-hidden>
        <span className="repression-fill" style={{ width: `${pct}%` }} />
      </span>
    </div>
  );
}
